import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import 'leaflet/dist/leaflet.css';

type RootErrorBoundaryState = { hasError: boolean; message: string };

class RootErrorBoundary extends React.Component<
  { children: React.ReactNode },
  RootErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error: unknown): RootErrorBoundaryState {
    const message = error instanceof Error ? error.stack || error.message : String(error);
    return { hasError: true, message };
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ padding: 16, fontFamily: 'monospace', color: '#fecaca', background: '#111827', minHeight: '100vh' }}>
        <h1 style={{ marginTop: 0 }}>Error de arranque en APLICACIONES</h1>
        <pre style={{ whiteSpace: 'pre-wrap' }}>{this.state.message}</pre>
      </div>
    );
  }
}

const root = document.getElementById('root');

if (!root) {
  throw new Error('No se encontró elemento #root en el HTML');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>
);

// PWA: registrar el service worker (app instalable + abre sin señal en campo).
// Solo en producción (en localhost con CRA dev el SW puede interferir con HMR).
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Buscar actualizaciones al cargar y cada vez que la pestaña vuelve al foco.
      reg.update().catch(() => {});
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') reg.update().catch(() => {});
      });
      // Cuando un SW nuevo toma el control, recargar UNA vez para usar el bundle nuevo.
      let recargado = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (recargado) return;
        recargado = true;
        window.location.reload();
      });
    }).catch((err) => {
      console.warn('SW no registrado:', err);
    });
  });
}
